import React from 'react';
import { EventTableRow, Event } from './EventTableRow';
import DataTableShell from '../common/DataTableShell';

interface EventTableProps {
    events: Event[];
    expandedRows: Set<string>;
    onToggleExpand: (eventId: string) => void;
    formatTimestamp: (timestamp: number) => string;
    truncateHash: (hash: string) => string;
}

export const EventTable: React.FC<EventTableProps> = ({ events, expandedRows, onToggleExpand, formatTimestamp, truncateHash }) => {
    return (
        <DataTableShell headers={[{ label: 'Event Name' }, { label: 'Tx Hash' }, { label: 'Block Number' }, { label: 'Timestamp' }, { label: 'Actions', align: 'center', className: 'w-24' }]}>
            {events.length === 0 ? (
                <tr>
                    <td colSpan={5} className="px-6 py-8 text-center text-gray-500">
                        No events found matching your filters
                    </td>
                </tr>
            ) : (
                events.map((event) => <EventTableRow key={event.id} event={event} isExpanded={expandedRows.has(String(event.id))} onToggleExpand={onToggleExpand} formatTimestamp={formatTimestamp} truncateHash={truncateHash} />)
            )}
        </DataTableShell>
    );
};
